/** @jsx jsx */
import { jsx } from 'theme-ui';

export const DefaultContainer = (props) => (
  <div
    {...props}
  />
);
